<template>
  <div :class="className">
    <component :is="headerTag" v-if="title">{{title}}</component>
    <slot></slot>
  </div>
</template>

<script>
import Flexer from "@/mixins/Flexer";

export default {
  name: "Panel",
  mixins: [Flexer],
  props: {
    title: String,
    col : { type: [Boolean, Object], default: true },
    small : { type: Boolean, default: false }
  },
  data() {
    return {
      clsName: 'panel',
      inheritsFlexyViaSass: true,
    }
  },
  computed : {
    headerTag() {
      if (this.small) return 'h3';
      return 'h1'
    }
  }
}
</script>
